import {
  RESET_USER_COURSE,
  RESET_USER_COURSE_SUCCESS,
  RESET_USER_COURSE_CLEAN,
  RESET_USER_COURSE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
}

const UserCourseReset = (state = initialState, action) => {
  switch (action.type) {
    case RESET_USER_COURSE:
      return { ...state, loading: true }
    case RESET_USER_COURSE_SUCCESS:
      return { ...state, loading: false, done: true }
    case RESET_USER_COURSE_CLEAN:
      return initialState
    case RESET_USER_COURSE_ERROR:
      return { ...state, error: action.payload, loading: false, done: false }
    default:
      return state
  }
}

export default UserCourseReset